'use client';
import React, { useState } from 'react';

export default function BrokerageDetails() {
  const [formData, setFormData] = useState({
    brokerageName: '',
    addressLine1: '',
    addressLine2: '',
    city: '',
    state: '',
    zipCode: '',
  });

  // Handle input field changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  // Handle form submission (for now, just log to console)
  const handleUpdate = (e) => {
    e.preventDefault();
    console.log('Brokerage details updated:', formData);
    // Logic to update the brokerage details can go here (API calls, etc.)
  };

  return (
    <div className=" p-6">

      {/* Form Section */}
      <form className="space-y-2 sm:space-y-4">
        {/* Brokerage Name */}
        <div className="mb-4">
          <input
            type="text"
            id="brokerageName"
            name="brokerageName"
            value={formData.brokerageName}
            onChange={handleChange}
            placeholder="Brokerage Name"
            className="mt-1 block w-full px-6 py-4 border border-gray-300 rounded-full shadow-sm text-sm sm:text-lg"
            required
          />
        </div>

        {/* Address Line 1 */}
        <div className="mb-4">
          <input
            type="text"
            id="addressLine1"
            name="addressLine1"
            value={formData.addressLine1}
            onChange={handleChange}
            placeholder="Address Line 1"
            className="mt-1 block w-full px-6 py-4 border border-gray-300 rounded-full shadow-sm  text-sm sm:text-lg"
            required
          />
        </div>

        {/* Address Line 2 (Optional) */}
        <div className="mb-4">
          <input
            type="text"
            id="addressLine2"
            name="addressLine2"
            value={formData.addressLine2}
            onChange={handleChange}
            placeholder="Address Line 2 (optional)"
            className="mt-1 block w-full px-6 py-4 border border-gray-300 rounded-full shadow-sm  text-sm sm:text-lg"
          />
        </div>

        {/* City and State */}
        <div className="mb-4 flex space-x-4">
          <div className="w-1/2">
            <input
              type="text"
              id="city"
              name="city"
              value={formData.city}
              onChange={handleChange}
              placeholder="City"
              className="mt-1 block w-full px-6 py-4 border border-gray-300 rounded-full shadow-sm  text-sm sm:text-lg"
              required
            />
          </div>
          <div className="w-1/2">
            <input
              type="text"
              id="state"
              name="state"
              value={formData.state}
              onChange={handleChange}
              placeholder="State"
              className="mt-1 block w-full px-6 py-4 border border-gray-300 rounded-full shadow-sm  text-sm sm:text-lg"
              required
            />
          </div>
        </div>

        {/* Zip Code */}
        <div className="mb-4">
          <input
            type="text"
            id="zipCode"
            name="zipCode"
            value={formData.zipCode}
            onChange={handleChange}
            placeholder="Zip Code"
            className="mt-1 block w-full px-6 py-4 border border-gray-300 rounded-full shadow-sm  text-sm sm:text-lg"
            required
          />
        </div>

        {/* Update Button */}
        <div className="mt-6 text-center">
          <button
            onClick={handleUpdate}
            className="py-[15px] px-6 bg-[#0062ff] text-white rounded-full hover:bg-blue-600  text-sm sm:text-lg w-full"
          >
            Update
          </button>
        </div>
      </form>
    </div>
  );
}
